import { useRSStore } from '../store/useRSStore'
import { readPincodeListAPI,removePincodeAPI,newPincodeAPI, updatePincodeAPI} from '../api/PincodeAPI'

import type { pincode } from '../types/types'


export function usePincode() {
  const RSStore = useRSStore()

  const onReadPincodeList = async () => {
    try {
      const list = await readPincodeListAPI()
     // RSStore.pincodeList = list
    //console.log("핀코드 데이터 로드 완료:", RSStore.pincodeList)
    } catch (e) {
      console.error("핀코드 데이터를 가져오는 중 에러 발생:", e)
    }
  }

  const onUpdatePincode = async (id: number) => {
    try {
      const result = await updatePincodeAPI(id)
      console.log("핀코드 업데이트 성공, ID:", result)
      RSStore.pincode = result
    } catch (e) {
      console.error("핀코드 업데이트 중 에러 발생:", e)
    }
  }
  const onNewPincode = async () => {
    try {
      const result = await newPincodeAPI()
      console.log("핀코드 생성 성공, ID:", result)
      RSStore.pincode = result
    } catch (e) {
      console.error("핀코드 생성 중 에러 발생:", e)
    }
  }

  const onRemovePincode = async (id: number) => {
    try {
      const result = await removePincodeAPI(id)
      if (result) {
        console.log("핀코드 삭제 성공, ID:", id)
      } else {
        console.error("핀코드 삭제 실패, ID:", id)
      }
    } catch (e) {
      console.error("핀코드 삭제 중 에러 발생:", e)
    }
  }

  return {
    onReadPincodeList,
    onNewPincode,
    onUpdatePincode,
    onRemovePincode
  }
}